import React from "react"
import { MyFormControlHelpers, CSuppense } from "@macashipo/mlib"

const V1_mfc_mycontrol = React.lazy(
  () => import("src/core/modules/v1page/MyForm/Types/v1_mfc_mycontrol")
)

const ListControl = {
  esc_date_flatpickr: "esc_date_flatpickr",
  check_with_icon: "check_with_icon",
  check_inbox: "check_inbox",
  select_year_month: "select_year_month",
  input_currency: "input_currency",
  date_flatpickr: "date_flatpickr",
  input_text: "input_text",
  input_date: "input_date",
  react_chartjs_2: "react_chartjs_2",
  checkbox_inbox: "checkbox_inbox",
  input_number: "input_number",
  input_percentage: "input_percentage",
  input_placeauto: "input_placeauto",
  input_placeauto_search_address: "input_placeauto_search_address",
  check_yes_no: "check_yes_no",
  year_picker: "year_picker",
  array_input: "array_input",
  check_custom_option: "check_custom_option",
  input_placeauto_search_rental_income: "input_placeauto_search_rental_income",
  input_api: "input_api",
  month_year_picker: "month_year_picker",
  input_textarea: "input_textarea",
  checkbox: "checkbox",
  checkbox_custom: "checkbox_custom",
  select2_icon_option: "select2_icon_option",
  input_time: "input_time",
  select_day: "select_day",
  select2_custom: "select2_custom",
  space: "space",
  select2_select_all: "select2_select_all",
  select_range_date: "select_range_date",
  readonly_html: "readonly_html",
  button_api: "button_api",
  input_multi_lines: "input_multi_lines",
  search_task_relation: "search_task_relation",
  editor_html: "editor_html",
  input_password_custom: "input_password_custom",
}
const MyFormControlOne = {
  init() {
    for (let k of Object.keys(ListControl)) {
      MyFormControlHelpers.addTypes(k, props => {
        return CSuppense({ ...props, typeControl: k }, V1_mfc_mycontrol)
      })
    }
  },
}

export default MyFormControlOne
